import { jsx as r } from "react/jsx-runtime";
import p from "react";
import { PaymentMethodEnum as t } from "@systemeio/ui";
import { StripeElementsProvider as a } from "./stripe/stripe-elements-provider.mjs";
import { StripePaymentMethodUsingPaymentElementEnum as n } from "./stripe/enum/stripe-payment-method-using-payment-element-enum.mjs";
const y = (o) => {
  switch (o) {
    case t.stripe_bancontact:
      return ({ children: e }) => /* @__PURE__ */ r(
        a,
        {
          paymentMethodType: n.Bancontact,
          children: e
        }
      );
    case t.stripe_applepay:
    case t.stripe_card:
      return ({ children: e }) => /* @__PURE__ */ r(a, { paymentMethodType: n.Card, children: e });
    case t.stripe_ideal:
      return ({ children: e }) => /* @__PURE__ */ r(
        a,
        {
          paymentMethodType: n.Ideal,
          children: e
        }
      );
    case t.stripe_klarna:
      return ({ children: e }) => /* @__PURE__ */ r(
        a,
        {
          paymentMethodType: n.Klarna,
          children: e
        }
      );
    default:
      return p.Fragment;
  }
};
export {
  y as getPaymentProcessorProvider
};
